<template>
  <div class="col-12">
    <p class="text-center mt-5">Step 2</p>
    <div class="text-center">
      <h1>Please Provide Your Mobile Number</h1>
    </div>
        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-10 col-lg-6">
             <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="submitForm()">

             <div class="ui big fluid left icon input mt-3">
            <i class="mobile alternate icon"></i>
            <input
              type="number"
              v-model="customer.mobileNumber"
              placeholder="Phone Number"
            />
          </div>
          <small v-if="errors.phone" class="text-danger">{{
            errors.phone
          }}</small>

           <button
            class="fluid ui button mt-3"
            v-bind:disabled="isBusy()"
            type="submit"
          >
            NEXT
          </button>
          <br />
          <a @click="close()" class="fluid ui grey tertiary button">Cancel</a>

             </form>
            </div> 
        </div>     
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
  name: 'PhoneNumber',
  data() {
  return {customer : {
  mobileNumber : ""
  },
    errors: {},
      operations: 0,
  };
  },
  mounted() {},
  methods: {
      close() {
      // todo: send close request to backend
    },
    submitForm() {
    console.log(localStorage.getItem('account-type').toString())
        localStorage.setItem("phone-number", this.customer.mobileNumber);
        if(localStorage.getItem('account-type').toString() === 'ISAVE') {
        this.$router.push("/account-opening/customer-details");
        }
        else this.$router.push("/account-opening/current-customer-details");

    },
    ...baseMethods,
  }
};
</script>